import { Breadcrumbs, Button, Card, CardActions, CardContent, FormControl, Grid, makeStyles, Typography } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { useSnackbar } from 'notistack';
import { FunctionComponent } from 'react';
import { Link, useHistory } from "react-router-dom";
import { AppInput } from '../components/atoms/inputs/AppInput';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';
import { ApiResponse } from '../types';

const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
}))

type TrackPensionerIdentityCardPageState = {
    applNo: string,
    erpId: string,
    message: { type: "error" | "success" | "warning" | "info", text: string } | null,
    rejectReason: string,

    file: any,
    fileName?: string,
}

type TrackPensionerIdentityCardPageProps = {
}

export const TrackPensionerIdentityCardPage: FunctionComponent<TrackPensionerIdentityCardPageProps> = () => {
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();
    const store = useStore();

    const getMaritalStatus = (maritialStat: any) => {
        if (maritialStat == '0') {
            return 'Single'
        }
        else if (maritialStat == 'M' || maritialStat == '1') {
            return 'Married'
        }
        else if (maritialStat == 'U') {
            return 'Unmarried'
        }
        else if (maritialStat == 'W' || maritialStat == '2') {
            return 'Widow'
        }
        else if (maritialStat == 'D' || maritialStat == '3') {
            return 'Divorcee'
        }
        else if (maritialStat == 'P') {
            return 'Physically Challanged'
        }
        else if (maritialStat == '4') {
            return 'NM'
        }
        else if (maritialStat == '5') {
            return 'Sep.'
        }
        else if (maritialStat == '6') {
            return 'Unknown'
        }
        else if (maritialStat == '9') {
            return 'RegCou'
        }
        else if (maritialStat == 'A') {
            return 'RegcRP'
        }
        else {
            return maritialStat
        }
    }

    const getSex = (sex: any) => {
        if (sex == 'M' || sex == '1') {
            return 'Male'
        }
        else if (sex == 'F' || sex == '2') {
            return 'Female'
        }
        else {
            return sex
        }
    }

    const getRelationWith = (relationWith: any) => {
        if (relationWith == 'S') {
            return 'Son'
        }
        else if (relationWith == 'D') {
            return 'Daughter'
        }
        else if (relationWith == 'W') {
            return 'Spouse'
        }
        else if (relationWith == 'F') {
            return 'Father'
        }
        else if (relationWith == 'M') {
            return 'Mother'
        }
        else {
            return relationWith
        }
    }

    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Formik
                    initialValues={{
                        applNo: store.auth.user?.id || '',
                        erpId: '',
                        message: null,
                        rejectReason: '',

                        file: null
                    }}
                    validate={(values) => {
                        const error: Partial<TrackPensionerIdentityCardPageState> & { general?: string } = {}
                        if (!values.applNo) {
                            error.applNo = "Invalid FPPO no"
                        }
                        // if (!values.erpId || !values.erpId.match(/^9\d{9}$/)) {
                        //     error.erpId = "Invalid ERP ID (অবৈধ ERP আইডি)"
                        // }
                        return error
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue, resetForm, setFieldTouched, setFieldError }) => {
                        setSubmitting(true)
                        if (!values.applNo || !values.applNo.match(/^\d{8}$|^[\d\/]{11}$/)) { //TODO Rectify Regex for legecy PPO
                            setFieldValue('message', { type: 'error', text: "Valid PPO Number Required (বৈধ পিপিও নম্বর প্রয়োজনীয়)" })
                            enqueueSnackbar("Valid PPO Number Required (বৈধ পিপিও নম্বর প্রয়োজনীয়)", { variant: 'error' });
                            return;
                        }
                        setFieldValue('message', null)
                        axios.get<ApiResponse<{}>>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONFETCHIDCARDDETAILSWS/FetchIdCardDetails`, {
                            params: {
                                ppoNum: {
                                    ppoNum: values.applNo
                                }
                            },
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        })
                            .then(
                                ({ data: resp, status: status }) => {
                                    console.log(resp);

                                    if (status === 200) {
                                        // resetForm();

                                        let user: any = resp;
                                        // user.applStatus = 'PENDING';
                                        if (user?.STATUS == 'A') {
                                            setFieldValue('rejectReason', '')
                                            setFieldValue('message', { type: 'success', text: "Your Id card is approved" })
                                            enqueueSnackbar("Your Id card status is approved", { variant: 'success' });
                                            // fetchPensionersCardDetails(resp);

                                            setSubmitting(true);

                                            let inputs = {
                                                "idCardNum": user?.ICARD_NO ?? "",
                                                "nameOfPensioner": user?.NAME ?? "",
                                                "ppoNum": values.applNo,
                                                "maritialStat": getMaritalStatus(user.MAR_STA) ?? "",
                                                "relationWith": getRelationWith(user.NOM_REL) ?? "",
                                                "address": user.RESIDENTIAL_ADDRESS ?? "",
                                                "sex": getSex(user.SEX) ?? "",
                                                "contactNo": user.CON_NO ?? "",
                                                "dateOfBirth": user.DOB ?? "",
                                                "dateOfCommencement": user.COM_OF_PEN ?? "",
                                                "imageExtension": user.IMAGE_EXTENSION ?? "",

                                                "ppoIssueDate": user?.PPO_ISSUE_DT ?? "",
                                                "postAtRetirement": user?.POST_AT_RETIREMENT ?? "",
                                                "dateOfRetirement": user?.RETIREMENT_DATE ?? "",

                                                "signatureExtension": user?.SIGNATURE_EXTENSION ?? "",
                                            }

                                            console.log(JSON.stringify(inputs));


                                            fetch(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONERGENERATEIDCARDWS/GeneratePensionerIdCard`, { body: JSON.stringify(inputs), method: 'post', })
                                                .then((response) => response.json())
                                                .then((resp) => {
                                                    // axios.post<any>(`${process.env.REACT_APP_NEW_API_ROOT}WBSEDCLERPPENSIONERGENERATEIDCARDWS/GeneratePensionerIdCard`, inputs,
                                                    //     {
                                                    //         headers: {
                                                    //             'Content-Type': 'application/json',
                                                    //         }
                                                    //     })
                                                    //     .then(({ data: resp }) => {
                                                    console.log(resp);
                                                    setFieldValue('fileName', `PensionersIdentityCard.pdf`)
                                                    setFieldValue('file', {
                                                        url: `${process.env.REACT_APP_NEW_API_ROOT}irj/go/km/docs${resp.pdfUrl}`,
                                                    })
                                                    setSubmitting(false)
                                                })
                                                .catch((error) => {
                                                    console.error(error);
                                                    setSubmitting(false)
                                                });
                                        }
                                        else if (user?.STATUS == 'R') {
                                            setFieldValue('rejectReason', user?.REJECTION_REASON ?? '')
                                            setFieldValue('message', { type: 'error', text: "Your application is rejected" })
                                            enqueueSnackbar("Your application is rejected", { variant: 'error' });
                                            setSubmitting(false)
                                        }
                                        else if (user?.STATUS == 'I') {
                                            setFieldValue('rejectReason', '')
                                            setFieldValue('message', { type: 'warning', text: "In Progress" })
                                            enqueueSnackbar("Your application is in progress", { variant: 'warning' });
                                            setSubmitting(false)
                                        }
                                        else {
                                            // setFieldValue('message', { type: '', text: user?.applStatus })
                                            // enqueueSnackbar(user?.applStatus || 'Error Occured', { variant: 'error' })
                                            setFieldValue('rejectReason', '');
                                            setFieldValue('message', { type: 'info', text: "You have not applied for a ID card yet" })
                                            enqueueSnackbar("You have not applied for a ID card yet", { variant: 'info' });
                                            setSubmitting(false)
                                        }
                                    }
                                    else {
                                        setFieldValue('rejectReason', '')
                                        setFieldValue('message', { type: 'error', text: "Something went wrong" })
                                        enqueueSnackbar("Something went wrong", { variant: 'error' })
                                        setSubmitting(false)
                                    }
                                },
                            )
                            .catch((e) => {
                                setFieldValue('message', { type: 'error', text: "Network error" })
                                enqueueSnackbar('Network error', { variant: 'error' })
                                setSubmitting(false)
                            })
                    }}
                >{({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange, setSubmitting }: FormikProps<TrackPensionerIdentityCardPageState>) => {
                    return (
                        <Form>
                            {
                                !values.file && !values.fileName &&
                                <Grid item>
                                    <Card className={classes.controlPaper}>
                                        <CardContent>
                                            <Grid container
                                                spacing={3}
                                                direction="column"
                                                justify="space-around"
                                                alignItems="stretch">

                                                <Grid item>
                                                    <Breadcrumbs>
                                                        <Link to="/" className={classes.link}>
                                                            <Typography gutterBottom variant="h5" component="h2">
                                                                <HomeIcon className={classes.icon} />Home</Typography>
                                                        </Link>
                                                        <Typography gutterBottom variant="h5" component="h2">Know Application Status / Download Identity Card (আবেদনপত্রের বর্তমান স্থীতি জানুন / পরিচয়পত্র ডাউনলোড করুন)</Typography>
                                                    </Breadcrumbs>
                                                </Grid>

                                                {/* <Grid item container justify="flex-start" alignItems="center">
                                                    <Grid item xs={10}><Typography variant="h6" color="initial">Know Application Status / Download Identity Card (আবেদনের স্থিতি জানুন / আইডেন্টিটি কার্ড ডাউনলোড করুন)</Typography></Grid>
                                                </Grid> */}
                                                {
                                                    values.message &&
                                                    <Grid item>
                                                        <Alert severity={values.message.type}>
                                                            <AlertTitle>
                                                                {values.message.type === "success" ? "Success" : values.message.type === "warning" ? "Pending" : values.message.type === "info" ? "Not Applied" : (values.message.type === "error" && values.message.text == 'Your application is rejected') ? "Rejected" : "Error(ত্রুটি)"}
                                                            </AlertTitle>
                                                            {values?.rejectReason ? values.rejectReason : values.message.text}
                                                        </Alert>
                                                    </Grid>
                                                }
                                                <Grid item>
                                                    <FormControl variant="filled" fullWidth>
                                                        <AppInput disabled fullWidth={true} inputProps={{ maxLength: 20 }} name="applNo" label={values.applNo.startsWith("800") ? "PPO No" : "FPPO No"} />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                        <CardActions>
                                            <LoadingButton
                                                type="submit"
                                                color="primary"
                                                variant="contained"
                                                size="large"
                                                loading={isSubmitting}
                                            >Get Application Status</LoadingButton>

                                            <Link to="/" className={classes.link}>
                                                <Button variant='contained' color='primary' size='large'>
                                                    Back (পিছনে)
                                                </Button>
                                            </Link>

                                        </CardActions>
                                    </Card>
                                </Grid>
                            }
                            {
                                !!values.file && !!values.fileName &&
                                < Grid item>
                                    <Card>
                                        <CardContent>
                                            <PdfViewer
                                                downloadFileName={values.fileName}
                                                file={values.file}
                                                onDocumentLoadSuccess={() => { setSubmitting(false) }}
                                                onDocumentLoadError={() => { setSubmitting(false) }}
                                                error={
                                                    <>
                                                        <Typography
                                                            variant="h6"
                                                            component="h6"
                                                            style={{ textAlign: "center" }}
                                                            color="secondary"
                                                        >Unable to load PDF (পিডিএফ লোড করতে অক্ষম)</Typography>
                                                    </>
                                                }
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            }
                            {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                        </Form>
                    )
                }}
                </Formik>
            </Grid>
        </AppShell>
    )
}